// extracted by mini-css-extract-plugin
export var stepActive = "_2i-3";
export var stepCompleted = "_2i-4";
export var stepConnectorLine = "_2i-b";
export var stepIndicatorCircle = "_2i-6";
export var stepIndicatorCircleCompleted = "_2i-7";
export var stepIndicatorCircleDefault = "_2i-8";
export var stepIndicatorTextCompleted = "_2i-9";
export var stepIndicatorTextDefault = "_2i-a";
export var stepPending = "_2i-5";
export var wizardContainer = "_2i-1";
export var wizardContent = "_2i-2";
export var wizardModal = "_2i-0";